export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/rays-ea2ae7b1fa5537c4d833384451bc6d33.svg";